import { Button, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { ColorTypeEnum } from 'theme';
import { MonthYearString } from 'types/MonthYearString';
import CollapsableCard from 'components/Generic/CollapsableCard';
import { ClosureContext } from 'pages/Closures/ClosureClose';
import InboundStockTable from './InboundStockTable';
import { InventoriedInboundStockForm } from './InventoriedInboundStockForm';

const useStyles = makeStyles({
  typography: {
    display: 'flex',
    width: '100%',
  },
  element: {
    'text-transform': 'capitalize',
    width: '25%',
  },
  mask: { overflow: 'hidden', maxWidth: '100%' },
  wrapper: {
    display: 'flex',
    width: '200%',
    position: 'relative',
    right: '0%',
    transition: 'right 0.3s ease',
  },
  wrapperSlide: {
    right: '100%',
  },
  panel: {
    width: '100%',
  },
});

type InboundStockCardProps = {
  isClosed: boolean;
  monthYearString: MonthYearString;
  readOnly?: boolean;
};

export const InboundStockCard: React.FC<InboundStockCardProps> = ({ isClosed, monthYearString, readOnly }) => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'sortingCenters.inboundStocks.view' });
  const [isInSecondPanel, setInSecondPanel] = useState<boolean>(false);
  const [formContext, setFormContext] = useState<ClosureContext | undefined>({});
  return (
    <CollapsableCard
      color={isClosed ? ColorTypeEnum.PRIMARY : ColorTypeEnum.WARNING}
      collapsableContent={
        monthYearString.month !== '1' || isClosed ? (
          <div className={classes.mask}>
            <div className={classNames({ [classes.wrapper]: true, [classes.wrapperSlide]: isInSecondPanel })}>
              <div className={classes.panel}>
                <InboundStockTable
                  month={Number(monthYearString.month)}
                  year={Number(monthYearString.year)}
                ></InboundStockTable>
                <div style={{ textAlign: 'right' }}>
                  <Button
                    onClick={() => setInSecondPanel(true)}
                    endIcon={<ArrowForwardIosIcon style={{ width: 10, height: 20 }} />}
                  >
                    {t('inventory')}
                  </Button>
                </div>
              </div>
              <div className={classes.panel}>
                <InventoriedInboundStockForm
                  year={monthYearString.year}
                  readOnly={true}
                  formContext={formContext}
                  setFormContext={setFormContext}
                />
                <div>
                  <Button
                    startIcon={<ArrowBackIosIcon style={{ width: 10, height: 20 }} />}
                    onClick={() => setInSecondPanel(false)}
                  >
                    {t('back')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <InventoriedInboundStockForm
            year={monthYearString.year}
            readOnly={readOnly}
            formContext={formContext}
            setFormContext={setFormContext}
          />
        )
      }
    >
      <Typography className={classes.typography}>
        <span className={classes.element}>{monthYearString.monthInLetter}</span>
        <span className={classes.element}>{monthYearString.year}</span>
      </Typography>
    </CollapsableCard>
  );
};
